import { Component, OnInit } from '@angular/core';
import { Practitioner } from '../../models/practitioner';
import { PhysicianService } from '../../../physician.service';
import { uniqBy } from 'lodash';

import { UserService } from "../../../../core/services/v2/user.service";

@Component({
  selector: 'app-mid-level-profiles',
  templateUrl: './mid-level-profiles.component.html',
  styleUrls: ['./mid-level-profiles.component.css']
})
export class MidLevelProfilesComponent implements OnInit {

  doctors: Practitioner[] = [];
  roles: string[] = [];

  constructor(
    private physicianService: PhysicianService,
    private userService: UserService
  ) { }

  ngOnInit() {

    this.physicianService.getMyHealthSystemPhysicians().subscribe(
      (p) => {
        let physicians = uniqBy(p, 'Id');
        physicians = physicians.filter(p => p.Users.length > 0)
          .filter(p => p.Users[0].Role !== 'Physician' && p.Users[0].PractitionerID !== null);

        this.doctors = physicians;
        this.filterRoles();
      },
      (error) => { console.error(error); }
    );

    this.userService.getRoles().subscribe(
      (result) => {
        this.roles = result.filter(x => x.Code.toLowerCase() === "midlevel").map(x => x.Name);
        this.filterRoles();
      },
      (error) => { console.error(error); }
    );


  }

  filterRoles() {
    if (!this.doctors.length || !this.roles.length) {
      return;
    }

    this.doctors = this.doctors.filter(x => this.roles.indexOf(x.Users[0].Role) !== -1);
  }

}
